import axios from "axios";
import { serviceUrl } from "../../config";

const BACKEND_URL = serviceUrl;

export const getBatchList = async () => {
  try {
    const data = JSON.stringify({
      svc: "m_batch",
      pid: "getBatchList",
      dat: {},
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const ScheduleEntryAdd = async (
  userid,
  scheduletime,
  inputfilename,
  uploadlocation,
  categoryid,
  totalrecords,
  notes,
  pin,
  amount = 0,
) => {
  let note;
  if (notes == undefined) {
    note = "";
  } else {
    note = notes;
  }
  try {
    const data = JSON.stringify({
      svc: "m_batch",
      pid: "ScheduleEntryAdd",
      dat: {
        userid: userid,
        scheduletime: scheduletime,
        inputfilename: inputfilename,
        uploadlocation: uploadlocation,
        categoryid: categoryid,
        totalrecords: totalrecords,
        notes: note,
        pin: pin,
        amount: parseFloat(amount) || 0,   // ← NEW
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const ScheduleEntryAdd3 = async (
  userid,
  scheduletime,
  inputfilename,
  uploadlocation,
  categoryid,
  totalrecords,
  notes,
  pin,
  amount = 0,
  uploadedby,
  approvedby,
  lastuserid,
  originalfilename = "",
  executionstatus = -2,
) => {
  let note;
  if (notes == undefined) {
    note = "";
  } else {
    note = notes;
  }
  try {
    const data = JSON.stringify({
      svc: "m_batch",
      pid: "ScheduleEntryAdd3",
      dat: {
        userid: userid,
        scheduletime: scheduletime,
        inputfilename: inputfilename,
        uploadlocation: uploadlocation,
        categoryid: categoryid,
        totalrecords: totalrecords,
        notes: note,
        pin: pin,
        amount: parseFloat(amount) || 0,
        uploadedby: uploadedby,
        approvedby: approvedby,
        lastuserid: lastuserid,
        originalfilename,
        executionstatus,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const ScheduleJobList2 = async (userid, rows) => {
  console.log(userid, rows);
  try {
    const data = JSON.stringify({
      svc: "m_batch",
      pid: "ScheduleJobList2",
      dat: {
        userID: userid,
        rows: rows,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const ScheduleJobList3 = async (rows) => {
  console.log(rows);
  try {
    const data = JSON.stringify({
      svc: "m_batch",
      pid: "ScheduleJobList3",
      dat: {
        rows: rows,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const deleteBatch = async (userid, requestid, pin) => {
  console.log(userid, requestid);
  try {
    const data = JSON.stringify({
      svc: "m_batch",
      pid: "ScheduleEntryDelete",
      dat: {
        userid: userid,
        requestid: requestid,
        pin: pin,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const editBatch = async (
  userid,
  requestid,
  pin,
  scheduletime,
  notes,
) => {
  console.log(userid, requestid);
  try {
    const data = JSON.stringify({
      svc: "m_batch",
      pid: "ScheduleEntryEdit",
      dat: {
        userid: userid,
        requestid: requestid,
        pin: pin,
        scheduletime: scheduletime,
        notes: notes,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getBatchUploadFiles = async (requestid) => {
  console.log(requestid);
  try {
    const data = JSON.stringify({
      svc: "m_batch",
      pid: "getBatchUploadFiles",
      dat: {
        requestid: requestid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const AddTransFileRecs = async (payload) => {
  try {
    const data = JSON.stringify({
      svc: "m_batch",
      pid: "AddTransFileRecs",
      dat: payload,
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: { "Content-Type": "application/json" },
      data: data,
    };

    const response = await axios(config);
    console.log("AddTransFileRecs response:", response.data);
    return response.data;
  } catch (error) {
    console.error("AddTransFileRecs failed:", error);
    throw error;
  }
};

export const ScheduleJobList4 = async ({
  location,
  rows = 20,
  requestid = 0,
  userid = 0,
  categoryid = 33,
  executionstatus,
}) => {
  try {
    const data = JSON.stringify({
      svc: "m_batch",
      pid: "ScheduleJobList4",
      dat: {
        location: location,
        rows: rows,
        requestid: requestid,
        userid: userid,
        categoryid: categoryid,
        executionstatus: executionstatus,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log("ScheduleJobList4 response:", response.data);

    return response.data; // Will have: { redirect, callStatus, payload }
  } catch (error) {
    console.error("ScheduleJobList4 failed:", error);
    throw error; // Let caller handle error (recommended)
  }
};

export const updateBatchStatus = async ({
  requestid,
  executionstatus,
  notes = "",
  pin,
  requestuserid,
  scheduletime = "",
  amount = 0,
  uploadedby,
  approvedby,
  lastuserid,
}) => {
  try {
    const response = await axios.post(
      BACKEND_URL,
      {
        svc: "m_batch",
        pid: "ScheduleEntryEdit3",
        dat: {
          location: "",
          requestid,
          requestuserid,
          pin,
          executionstatus,
          notes: notes.trim(),
          scheduletime,
          amount: parseFloat(amount) || 0,
          uploadedby: uploadedby,
          approvedby: approvedby,
          lastuserid: lastuserid,
        },
      },
      {
        headers: { "Content-Type": "application/json" },
      },
    );

    return response.data;
  } catch (error) {
    console.error(
      "updateBatchStatus failed:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const UpdateTransFileRecs = async (record) => {
  try {
    const data = JSON.stringify({
      svc: "m_batch",
      pid: "UpdateTransFileRecs",
      dat: {
        location: record.location,
        recid: record.recid,
        firstname: record.firstname,
        lastname: record.lastname,
        birthdate: record.birthdate,
        address1: record.address1,
        address2: record.address2,
        country: record.country,
        state: record.state,
        zipcode: record.zipcode,
        phoneno: record.phoneno,
        phoneno2: record.phoneno2,
        email: record.email,
        currency: record.currency,
        amount: record.amount,
        comment: record.comment,
        purposeofaccount: record.purposeofaccount,
        status: record.status,
        errormessage: record.errormessage,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log("UpdateTransFileRecs response:", response.data);

    return response.data;
  } catch (error) {
    console.error("UpdateTransFileRecs failed:", error);
    throw error;
  }
};

export const ListTransFileRecs = async (requestid, userid, status) => {
  try {
    const data = JSON.stringify({
      svc: "m_batch",
      pid: "ListTransFileRecs",
      dat: {
        location: "",
        requestid: requestid,
        userid: userid,
        status: status,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log("ListTransFileRecs response:", response.data);

    return response.data;
  } catch (error) {
    console.error("ListTransFileRecs failed:", error);
    throw error;
  }
};

export const GetMerchantProfile = async (location, userid) => {
  try {
    const data = JSON.stringify({
      svc: "m_batch",
      pid: "GetMerchantProfile",
      dat: {
        location: location,
        userid: userid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log("GetMerchantProfile response:", response.data);

    return response.data;
  } catch (error) {
    console.error("GetMerchantProfile failed:", error);
    throw error;
  }
};

export const sendEmail2 = async ({
  destinationEmailAccount,
  subject,
  emailText,
}) => {
  try {
    const data = JSON.stringify({
      svc: "m_batch",
      pid: "SendEmail2",
      dat: {
        location: "",
        destinationEmailAccount: destinationEmailAccount,
        subject: subject,
        emailText: emailText,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log("SendEmail2 response:", response.data);

    return response.data;
  } catch (error) {
    console.error("sendEmail2 failed:", error.response?.data || error.message);
    throw error;
  }
};
export const ValidatePayrollFileRecords = async (userDetails) => {
  try {
    const data = JSON.stringify({
      svc: "m_batch",
      pid: "ValidatePayrollFileRecords",
      dat: {
        location: "",
        userdetails: JSON.stringify(userDetails).replace(/"/g, "&quot;"), // string, not array
      },
    });

    console.log("[ValidatePayrollFileRecords] Raw request body:", data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: { "Content-Type": "application/json" },
      data: data,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.error("ValidatePayrollFileRecords failed:", error);
    throw error;
  }
};

export const SendEmailWithAttachment3 = async ({
  userid,
  from,
  recipient,
  cc,
  subject,
  emailText,
  attachedfilename,
  fromname,
}) => {
  try {
    const data = JSON.stringify({
      svc: "m_batch",
      pid: "SendEmailWithAttachment3",
      dat: {
        location: "",
        userid: userid,
        from: from,
        recipient: recipient,
        cc: cc,
        subject: subject,
        emailtext: emailText,
        attachedfilename: attachedfilename,
        fromname: fromname,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log("SendEmail3 response:", response.data);

    return response.data;
  } catch (error) {
    console.error("sendEmail3 failed:", error.response?.data || error.message);
    throw error;
  }
}
  export const DeleteTransFileRecs = async ({ recId }) => {
    try {
      const data = JSON.stringify({
        svc: "m_batch",
        pid: "DeleteTransFileRecs",
        dat: {
          location: "",
          recid: recId,
        },
      });

      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      const response = await axios(config);
      console.log("Delete trans record response:", response.data);

      return response.data;
    } catch (error) {
      console.error(
        "Delete trans record failed",
        error.response?.data || error.message,
      );
      throw error;
    }
  };
  export const ScheduleJobList5 = async ({
  location,
  rows = 0,
  requestid = 0,
  userid = 0,
  categoryid = 0,
  executionstatus,
  inputfilename
}) => {
  try {
    const data = JSON.stringify({
      svc: "m_batch",
      pid: "ScheduleJobList5",
      dat: {
        location: location,
        rows: rows,
        requestid: requestid,
        userid: userid,
        categoryid: categoryid,
        executionstatus: executionstatus,
        inputfilename: inputfilename
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log("ScheduleJobList4 response:", response.data);

    return response.data; // Will have: { redirect, callStatus, payload }
  } catch (error) {
    console.error("ScheduleJobList4 failed:", error);
    throw error; // Let caller handle error (recommended)
  }
};
export const ScheduleJobList6 = async ({
  location = "",
  rows = 0,
  requestid = 0,
  userid = 0,
  categoryid = 0,
  executionstatus = "",
  originalfilename = "",
}) => {
  const data = JSON.stringify({
    svc: "m_batch",
    pid: "ScheduleJobList6",
    dat: {
      location,
      rows,
      requestid,
      userid,
      categoryid,
      executionstatus,
      originalfilename,
    },
  });

  const response = await axios({
    method: "post",
    url: BACKEND_URL,
    headers: { "Content-Type": "application/json" },
    data,
  });

  return response.data;
};
export const ListPayrollEmployees = async (adminid) => {
  const data = JSON.stringify({
    svc: "m_batch",
    pid: "ListPayrollEmployees",
    dat: {
      location: "",
      adminid,
    },
  });

  const response = await axios({
    method: "post",
    url: BACKEND_URL,
    headers: { "Content-Type": "application/json" },
    data,
  });

  const result = response.data;
  return {
    callStatus: result?.data?.header?.callStatus ?? result?.callStatus ?? "0",
    payload: result?.data?.body ?? result?.payload ?? [],
  };
};
